import {getType, resolveIdentifier, types} from "mobx-state-tree";
// import ParameterSet from "../../../models/parameterSets/ParameterSetModel";
import ParameterSetStore from "../../../stores/domain/ParameterSetStore";
import {ParameterSet} from "../../../models/parameterSets/ParameterSetModel";
import {Utm} from "../../../models/utms/UtmModel";

export const ParameterSetSelectState = types.model('ParameterSetSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.late(() => types.reference(ParameterSetStore))),
  selected: types.maybe(types.safeReference(ParameterSet)),
}).volatile((self)=>({
  notifySelect: types.str,
})).actions((self) => ({
  search(txt){
    //self.groupOptions = self.groupStore.searchFor(txt)
    //self.groupStore.groups
  },
  setConsumer(f){
    self.notifySelect = f
  },
  select(parameterSet) {
    if(parameterSet && parameterSet.uuid) {
      self.notifySelect(parameterSet.uuid)
      self.selected = resolveIdentifier(ParameterSet, self, parameterSet.uuid)
    }
    else{
      self.selected = undefined
    }
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => {
      console.log("placeholder notifySelect")
    }

    self.selectedSchema = {}
  },
  setSelectedParameterSet(c) {
    if(c) {
      self.selected = resolveIdentifier(ParameterSet, self, c?.uuid || c)
    } else {
      self.selected = undefined
    }
  },
  clearSelection(){
    self.selected = null
  }
})).views( (self) => ({
  options() {
    const list = self?.store?.filteredList() || [];
    return list.slice().sort((a,b) => a?.label?.localeCompare(b?.label))
  },
}))


